/*
 * Copyright (c) Dito Technologies
 */

import React, {MouseEventHandler} from "react";
import styles from "./Button.module.scss"
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {IconDefinition} from "@fortawesome/fontawesome-svg-core";
import classnames from "classnames";

interface Props {
    title: string;
    icon?: IconDefinition;
    onClick?: MouseEventHandler<HTMLDivElement>;
    disabled?: boolean;
    size?: "small" | "large";
    purpose?: "normal" | "destructure"
}

const Button: React.FC<Props> = ({size, title, icon, onClick, disabled, purpose: purposeRaw}) => {
    const purpose = purposeRaw || "normal";
    return (
        <div className={classnames(styles.container, {
            [styles.containerEnabled]: !disabled,
            [styles.normalEnabled]: !disabled && purpose === "normal",
            [styles.destructiveEnabled]: !disabled && purpose === "destructure",
            [styles.normal]: purpose === "normal",
            [styles.destructive]: purpose === "destructure"
        })} onClick={disabled ? undefined : onClick}>
            {icon ?
                <div className={styles.iconContainer}>
                    <FontAwesomeIcon size={size === "small" ? "xs" : "1x"} icon={icon}/>
                </div> : null}
            <span className={size === "small" ? styles.textSmall : styles.textLarge}>
                {title}
            </span>
        </div>
    );
}

export default Button;

